import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
    FiUser,
    FiInfo,
    FiBriefcase,
    FiBookOpen,
    FiLink,
    FiEdit3,
} from "react-icons/fi";

const tabs = [
    { name: "Profile", path: "/instructor/my/profile", icon: FiUser },
    { name: "Basic Information", path: "/instructor/my/basic-info", icon: FiInfo },
    { name: "Experience", path: "/instructor/my/experience", icon: FiBriefcase },
    { name: "Education", path: "/instructor/my/education", icon: FiBookOpen },
    { name: "Social Links", path: "/instructor/my/social-links", icon: FiLink },
    { name: "About you", path: "/instructor/my/about", icon: FiEdit3 },
];

const ProfileTabs = () => {

    const location = useLocation();
    const containerRef = useRef(null);
    const tabRefs = useRef([]);

    const [indicatorStyle, setIndicatorStyle] = useState({});

    //AUTO FOLLOW ACTIVE TAB (MOBILE FIX)
    useEffect(() => {

        const index = tabs.findIndex(t =>
            location.pathname.startsWith(t.path)
        );

        const activeTab = tabRefs.current[index];
        const container = containerRef.current;

        if (!activeTab || !container) return;

        // sliding bar
        setIndicatorStyle({
            width: activeTab.offsetWidth + "px",
            transform: `translateX(${activeTab.offsetLeft}px)`
        });

        // 👇 THIS FIXES MOBILE AUTO SCROLL
        const scrollLeft =
            activeTab.offsetLeft -
            container.clientWidth / 2 +
            activeTab.clientWidth / 2;

        container.scrollTo({
            left: scrollLeft,
            behavior: "smooth"
        });

    }, [location.pathname]);

    return (
        <div className="sticky top-0 bg-white z-20">

            {/* 👇 IMPORTANT MOBILE FIXES */}
            <div
                ref={containerRef}
                className="
          relative
          flex
          items-center
          gap-4
          overflow-x-auto
          whitespace-nowrap
          w-full
          no-scrollbar
          border-b
        "
            >

                {/* SLIDING BAR */}
                <span
                    className="absolute bottom-0 left-0 h-[3px] bg-primary-600 transition-all duration-300"
                    style={indicatorStyle}
                />

                {tabs.map((tab, i) => {
                    const Icon = tab.icon;

                    return (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            ref={(el) => (tabRefs.current[i] = el)}
                            className={({ isActive }) =>
                                `
                flex-shrink-0
                flex items-center gap-2
                px-3
                pt-3 pb-3
                text-xs sm:text-sm
                font-medium
                transition
                ${isActive
                                    ? "text-primary-600"
                                    : "text-gray-500 hover:text-gray-900"}
                `
                            }
                        >
                            <Icon size={18} />
                            <span>{tab.name}</span>
                            <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                        </NavLink>
                    );
                })}

            </div>
        </div>
    );
};

export default ProfileTabs;
